module.exports = __webpack_public_path__ + "img/5.da88fc61.png";